import React, {useState} from 'react'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import {notification} from 'antd'
import Query from 'components/shared/Query'
import Button from 'components/shared/Button'
import ExistingAssets from './ExistingAssets'
import UploadAssets from './UploadAssets'
import './index.scss'

export const getInputAssetsQuery = gql`
  query GetInputAssetsQuery($productId: ID!) {
    product(id: $productId) {
      id
      ...on InputAssetsBasedProduct {
        inputAssets {
          edges {
            node {
              id
              ...on PhotoAsset {
                image(size: "monitor") {
                  url
                  thumbUrl
                  width
                  height
                  labels
                  filenameIndex
                }
              }
              ...on DocumentAsset {
                url
              }
            }
          }
        }
      }
    }
  }
`

const submitInputMutation = gql`
  mutation SubmitInput($productId: ID!) {
    SubmitInput(productId: $productId) {
      product {
        id
        state
        requiresUserInput
        canProvideUserInput
      }
    }
  }
`

const ProductInputAssets = ({product, description}) => {
  const [loading, setLoading] = useState(false)

  return (
    <Query
      inlineLoading
      inlineError
      query={getInputAssetsQuery}
      variables={{productId: product.id}}
    >
      {({getData}) => {
        const assets = getData('product.inputAssets.edges', []).map(e => e.node)
        return (
          <div className="product-input-assets">
            <ExistingAssets
              product={product}
              description={description}
              assets={assets}
              onLoadingChanged={setLoading}
            />

            <UploadAssets
              product={product}
              onLoadingChanged={setLoading}
            />

            {assets.length > 0 && (
              <div className="actions">
                <Mutation
                  mutation={submitInputMutation}
                  onCompleted={() => {
                    notification.success({
                      message: 'Underlag lastet opp',
                      description: 'Underlaget ble lastet opp og produktet sendes nå til produksjon.',
                    })
                  }}
                  onError={() => {
                    notification.error({
                      message: 'Underlag feilet',
                      description: 'Kunne ikke laste opp underlag grunnet en feil. Forsøk på nytt senere.',
                    })
                  }}
                >
                  {(submitInputAssets, {loading: isSubmitting}) => (
                    <Button
                      type="action"
                      loading={isSubmitting}
                      disabled={isSubmitting || loading}
                      onClick={() => {
                        return submitInputAssets({
                          variables: {
                            productId: product.id,
                          }
                        })
                      }}
                    >
                      Send til produksjon
                    </Button>
                  )}
                </Mutation>
              </div>
            )}
          </div>
        )
      }}
    </Query>
  )
}

export default ProductInputAssets
